import { UrlSegments } from '../app/Helpers';
import { WaitForElementToDisplay } from '../app/Helpers/WaitForElementToDisplay';

let root = UrlSegments(0);

export const SalesPages = new Promise(() => {

    let isSales = false;

    if (root === "SalesManager") {
        isSales = true;
    }
    if (root === "SalesRep") {
        isSales = true;
    }

    if (!isSales) {
        return;
    }

    let section = UrlSegments(1);

    if (section === "ItemSearch") {
        import('../app/ViewModels/Sales/ItemSearch' /* webpackChunkName: "item-search" */).then((viewModel) => {
            console.info("Initializing ItemSearchVM...")

            let vm = window.vm = new viewModel.ItemSearchVM();

            WaitForElementToDisplay("#item-search-grid", 500, () => { ko.applyBindings(vm, document.getElementById('item-search-grid')) });
        });
    }

    if (section === "SalesGoals") {
        import('../app/ViewModels/Sales/SalesGoal' /* webpackChunkName: "sales-goal" */).then((viewModel) => {
            console.info("Initializing SalesGoalVM...")
            let model = window.Model;
            let vm = window.vm = new viewModel.SalesGoalVM(model);

            WaitForElementToDisplay("#sales-goals", 500, () => { ko.applyBindings(vm, document.getElementById('sales-goals')) });
        });
    }

    let isSalesActivity = false;
    let isSalesBonusReport = false;
    if (section === "SalesActivityDashboard") {
        isSalesActivity = true;
    }
    if (section === "SalesActivity") {
        isSalesActivity = true;
    }

    if (section === "ViewQuarterlyBonusReport") {
        isSalesBonusReport = true;
    }


    if (isSalesActivity) {
        import('../app/ViewModels/Sales/SalesActivityDashboard' /* webpackChunkName: "sales-activity-dashboard" */).then((viewModel) => {
            console.info("Initializing SalesActivityDashboard VM...")
            let model = window.Model;
            let vm = window.vm = new viewModel.SalesActivityDashboard(model);

            WaitForElementToDisplay("#sales-activity-grid", 500, () => { ko.applyBindings(vm, document.getElementById('sales-activity-grid')) });
            WaitForElementToDisplay("#date-range-picker", 500, () => { ko.applyBindings((<any>vm).SalesActivityRange, document.getElementById('date-range-picker')) });
        });
    }
    if (isSalesBonusReport) {
        import('../app/ViewModels/Sales/QuarterlySalesReport' /* webpackChunkName: "sales-activity-dashboard" */).then((viewModel) => {
            console.info("Initializing QuarterlySalesReport VM...")
            let model = window.Model;
            console.log('model is');
            console.log(model);
            let vm = window.vm = new viewModel.QuarterlySalesReport(model);
            console.log('vm is');
            console.log(vm);
            WaitForElementToDisplay("#sales-activity-grid", 500, () => { ko.applyBindings(vm, document.getElementById('sales-activity-grid')) });
            //WaitForElementToDisplay("#date-range-picker", 500, () => { ko.applyBindings((<any>vm).SalesActivityRange, document.getElementById('date-range-picker')) });
            //WaitForElementToDisplay("#selectedYear", 500, () => { ko.applyBindings((<any>vm).YearList, document.getElementById('selectedYear')) });
            //WaitForElementToDisplay("#selectedQuarter", 500, () => { ko.applyBindings((<any>vm).QuarterList, document.getElementById('selectedQuarter')) });
    });
    }
    if (section === "CustomerStatusPanel") {
        import('../app/ViewModels/Sales/CustomerStatusPanel' /* webpackChunkName: "customer-status-panel" */).then((viewModel) => {
            console.info("Initializing CustomerStatusPanel VM...");
            let model = window.Model;
            let vm = window.vm = new viewModel.CustomerStatusPanel(model);

            WaitForElementToDisplay("#customer-status-panel", 500, () => { ko.applyBindings(vm, document.getElementById('customer-status-panel')) });
        });
    }
    if (section === "QuoteTemplate") {
        import('../app/ViewModels/Sales/QuoteTemplate' /* webpackChunkName: "customer-status-panel" */).then((viewModel) => {
            console.info("Initializing QuoteTemplate VM...");
            let model = window.Model;
            let vm = window.vm = new viewModel.QuoteTemplate(model);
            console.info('in sales.ts');
            console.info(vm);
            WaitForElementToDisplay("#customer-status-panel", 500, () => { ko.applyBindings(vm, document.getElementById('customer-status-panel')) });
        });
    }

    if (root === "SalesManager") {
        if (section === "BusinessReview") {
            import('../app/ViewModels/Sales/BusinessReview' /* webpackChunkName: "business-review" */).then((viewModel) => {
                console.info("Initializing BusinessReview VM...");
                let model = window.Model;
                let vm = window.vm = new viewModel.BusinessReview(model);

                WaitForElementToDisplay("#business-review-grid", 500, () => { ko.applyBindings(vm, document.getElementById('business-review-grid')) });
                WaitForElementToDisplay("#business-review-range", 500, () => { ko.applyBindings((<any>vm).BusinessReviewRange, document.getElementById('business-review-range')) });
            });
        }

        if (section === "Rolling13") {
            import('../app/ViewModels/Sales/Rolling13' /* webpackChunkName: "rolling-13" */).then((viewModel) => {
                console.info("Initializing Rolling13 VM...");
                let model = window.Model;
                let vm = window.vm = new viewModel.Rolling13VM(model);


                WaitForElementToDisplay("#rolling13-report", 500, () => { ko.applyBindings(vm, document.getElementById('rolling13-report')) });
                WaitForElementToDisplay("#rolling13-date-range", 500, () => { ko.applyBindings(<any>vm.Rolling13DateRange, document.getElementById('rolling13-date-range')) });
            });
        }

        if (section === "Engagement") {
            import('../app/ViewModels/Sales/Engagement' /* webpackChunkName: "engagement" */).then((viewModel) => {
                console.info("Initializing Engagement VM...");
                let model = window.Model;
                let vm = window.vm = new viewModel.Engagement(model);


                WaitForElementToDisplay("#customer-engagement", 500, () => { ko.applyBindings(vm, document.getElementById('customer-engagement')) });
            });
        }

        if (section === "RetentionReport") {
            import('../app/ViewModels/Sales/RetentionReport' /* webpackChunkName: "engagement" */).then((viewModel) => {
                console.info("Initializing Engagement VM...");
                let model = window.Model;
                let vm = window.vm = new viewModel.RetentionReport(model);

                WaitForElementToDisplay("#retention-report", 500, () => { ko.applyBindings(vm, document.getElementById('retention-report')) });
                WaitForElementToDisplay("#retention-date-range", 500, () => { ko.applyBindings((<any>vm).RetentionDateRange, document.getElementById('retention-date-range')) });
            });
        }
    }
})